export default {
  // eslint-disable-next-line
  uuidv4: () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  collapseTemplate: (template) => {
    // eslint-disable-next-line
    const activeTemplate = JSON.parse(JSON.stringify(template));

    activeTemplate.data.divisions[0].sectionResources.forEach((sr) => {
      // skip if already collapsed
      if (typeof sr.coreResource === 'object') {
        // eslint-disable-next-line
        sr.coreResource = sr.coreResource.id;
        // eslint-disable-next-line
        sr.flows[0].formula = sr.flows[0].formula ? sr.flows[0].formula.id : null;
        sr.flows[0].fcst.forEach((f) => {
          const isCurrency = typeof f.scenarios[0].units === 'object';
          if (isCurrency) {
            const defaultCurrency = template.data.coreResources.find((cr) => cr.rel === 'currency' && cr.isDefault);
            // eslint-disable-next-line
            f.scenarios[0].units = defaultCurrency.id;
          }
        });
      }
    });

    activeTemplate.data.env.sectionResources.forEach((sr) => {
      // skip if already collapsed
      if (typeof sr.coreResource === 'object') {
        // eslint-disable-next-line
        sr.coreResource = sr.coreResource.id;
        // eslint-disable-next-line
        sr.flows[0].formula = sr.flows[0].formula ? sr.flows[0].formula.id : null;
      }
    });

    activeTemplate.data.sections.forEach((section) => {
      // eslint-disable-next-line
      delete section.sectionResources;
    });

    delete activeTemplate.expanded;
    delete activeTemplate.previewModules;
    // if from static template
    delete activeTemplate.previewData;

    return activeTemplate;
  },
  getSectionById(sectionId) {
    let result;
    this.$store.getters.sections.forEach((section) => {
      if (section.sections) {
        section.sections.forEach((sect) => {
          if (sect.id === sectionId) {
            result = sect;
          }
        });
      }
      if (section.id === sectionId) {
        result = section;
      }
    });
    return result;
  },
};
